module.exports = __webpack_public_path__ + "img/anli.0b4872ec.png";